import logo from "../assets/logo.png";
import "./Footer.css";

const LINKS = ["Home","About","Services","Projects","Gallery","Team","Contact"];

export default function Footer() {
  const year = new Date().getFullYear();
  const scrollTo = (id) =>
    document.getElementById(id.toLowerCase())?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="footer">
      <div className="footer-top container">
        <div className="footer-brand">
          <div className="footer-logo-row" onClick={() => scrollTo("home")} style={{cursor:"pointer"}}>
            <img src={logo} alt="Everlink" />
            <div>
              <p className="footer-name">Everlink Telesat Network Limited</p>
              <p className="footer-inc">Incorporated 17 September 1991</p>
            </div>
          </div>
        </div>
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            {LINKS.map((l) => (
              <li key={l}><button onClick={() => scrollTo(l)}>{l}</button></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="footer-bottom container">
        <p>© {year} Everlink Telesat Network Limited. All rights reserved.</p>
      </div>
    </footer>
  );
}
